import { GEO_DATA } from 'src/dataLayer/env';

const gdprCountries = new Set([
  'AUT', 'BEL', 'BGR', 'HRV', 'CYP', 'CZE',
  'DNK', 'EST', 'FRA', 'DEU', 'GRC', 'HUN',
  'IRL', 'ITA', 'LVA', 'LTU', 'LUX', 'MLT',
  'NLD', 'ANT', 'NOR', 'POL', 'PRT', 'ROU',
  'SVK', 'SVN', 'ESP', 'SWE', 'CHE', 'GBR'
]);

export const getGdprOptions = (): boolean => GEO_DATA ? gdprCountries.has(GEO_DATA.countryCode3) : false;
